<script setup>
const site = useState('site')
</script>

<template lang="pug">
div(v-if="site && site.hostMap").my-4
  iframe.block.w-full(:src="site.hostMap" style="height: 450px")
</template>
